import request from '@/plugins/request'

export function getCategoryList(key, pageindex, pagesize) {
    return request({
        url: '/v1/TypeCate/GetCateList',
        method: 'post',
        data: {
            key: key,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function CategoryEdit(Id, cateName, state) {
    return request({
        url: '/v1/TypeCate/EditCate',
        method: 'post',
        data: {
            id: Id,
            cateName: cateName,
            state: state
        }
    })
}

export function CategoryDel(Id) {
    return request({
        url: '/v1/TypeCate/DelCate',
        method: 'post',
        data: {
            id: Id,
        }
    })
}

export function getCateSelList() {
    return request({
        url: '/v1/TypeCate/GetCateSelList',
        method: 'get'
    })
}